import React from 'react';
import { SkeletonLine } from 'wix-ui-tpa/cssVars';
import { classes } from './Skeleton.st.css';
export const Skeleton = _ref => {
  let {
    layout
  } = _ref;
  /* istanbul ignore else */
  if (layout === 'vertical') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SkeletonLine, {
      className: classes.skeletonLine
    }), /*#__PURE__*/React.createElement(SkeletonLine, {
      className: classes.skeletonLine
    }));
  }

  /* istanbul ignore next */
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("fieldset", {
    className: classes.fieldset
  }, /*#__PURE__*/React.createElement("legend", null, /*#__PURE__*/React.createElement(SkeletonLine, {
    className: classes.legendSkeletonLine
  })), /*#__PURE__*/React.createElement(SkeletonLine, {
    className: classes.horizontalSkeletonLine
  }), /*#__PURE__*/React.createElement(SkeletonLine, {
    className: classes.horizontalSkeletonLine
  })), /*#__PURE__*/React.createElement("fieldset", {
    className: classes.skeletonBottomLine
  }, /*#__PURE__*/React.createElement("legend", null, /*#__PURE__*/React.createElement(SkeletonLine, {
    className: classes.bottomLegendSkeletonLine
  }))));
};
//# sourceMappingURL=Skeleton.js.map